(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carrco-chatgpt-print"] && !Shopify.designMode) return;
  try {
    
(function(){
  const roots = document.querySelectorAll('.ccai');

  function emit(root, name, data) {
    document.dispatchEvent(new CustomEvent('carrco:analytics', { detail: { name: name, data: Object.assign({ section_id: root.dataset.sectionId }, data || {}) } }));
  }

  function humanFileSize(bytes) {
    if (bytes < 1024 * 1024) return Math.max(1, Math.round(bytes / 1024)) + ' KB';
    return (bytes / 1024 / 1024).toFixed(1) + ' MB';
  }

  function snap(value) {
    return Math.max(.5, Math.round(value * 2) / 2);
  }

  roots.forEach(function(root){
    const copy = root.dataset;
    const orderForm = root.querySelector('.ccai__order-form');
    const fileInput = root.querySelector('.ccai__file-input');
    const dropzone = root.querySelector('.ccai__dropzone');
    const emptyState = root.querySelector('.ccai__empty-state');
    const preview = root.querySelector('.ccai__preview');
    const previewImage = preview.querySelector('img');
    const pdfPreview = preview.querySelector('.ccai__pdf-preview');
    const status = root.querySelector('.ccai__file-status');
    const diagnostics = root.querySelector('.ccai__diagnostics');
    const widthInput = root.querySelector('.ccai__width');
    const heightInput = root.querySelector('.ccai__height');
    const quantityGrid = root.querySelector('.ccai__quantity-grid');
    const totalOutput = root.querySelector('[data-price="total"]');
    const eachOutput = root.querySelector('[data-price="each"]');
    const chargedOutput = root.querySelector('[data-price="charged"]');
    const continueButton = root.querySelector('.ccai__continue');
    const continueLabel = root.querySelector('[data-continue-label]');
    const checkoutButton = root.querySelector('.ccai__checkout');
    const checkoutLabel = root.querySelector('[data-checkout-label]');
    const rightsInput = root.querySelector('.ccai__rights input');
    const checkoutReturn = orderForm.querySelector('[data-checkout-return]');
    const orderResult = root.querySelector('.ccai__order-result');
    const variantInput = orderForm.querySelector('[name="id"]');
    const finishProperty = orderForm.querySelector('[name="properties[Finish]"]');
    const requestedSizeProperty = orderForm.querySelector('[name="properties[Requested Size]"]');
    const cutSizeProperty = orderForm.querySelector('[name="properties[Cut Size]"]');
    const shapeProperty = orderForm.querySelector('[name="properties[Shape]"]');
    const sourceProperty = orderForm.querySelector('[name="properties[_AI source]"]');
    const fileNameProperty = orderForm.querySelector('[name="properties[_AI artwork filename]"]');
    const mobileBar = root.querySelector('.ccai__mobile-bar');
    const mobileButton = mobileBar.querySelector('button');
    const mobileFile = mobileBar.querySelector('[data-mobile="file"]');
    const mobilePrice = mobileBar.querySelector('[data-mobile="price"]');
    const state = { file: null, imageWidth: 0, imageHeight: 0, transparent: false, shape: 'custom', route: root.dataset.customUrl, width: 3, height: 3, quantity: 25, finish: 'Glossy', product: null, variant: null, objectUrl: '' };
    const productCache = new Map();
    let configurationTouched = false;
    let priceRequest = 0;
    let submitting = false;
    let checkoutIntent = false;
    let addedConfigurationKey = '';

    function setPressed(buttons, active) {
      buttons.forEach(function(button){
        const selected = button === active;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
    }

    function sourceFromVisit() {
      const referrer = document.referrer || '';
      const params = new URLSearchParams(window.location.search);
      if (/chatgpt\.com|chat\.openai\.com/i.test(referrer) || /chatgpt/i.test(params.get('utm_source') || '')) return 'chatgpt_confirmed';
      return 'carrco_ai_studio';
    }

    function sourceLabel() {
      return sourceFromVisit() === 'chatgpt_confirmed' ? 'ChatGPT confirmed' : 'Carrco AI print studio';
    }

    function setPurchaseLabels() {
      const price = totalOutput.textContent && totalOutput.textContent !== '—' ? ' · ' + totalOutput.textContent : '';
      continueLabel.textContent = copy.copyAddToCart;
      checkoutLabel.textContent = copy.copyCheckout + price;
    }

    function purchaseReady() {
      return Boolean(state.file && state.variant && variantInput.value && rightsInput.checked);
    }

    function syncPurchaseAvailability() {
      const canPurchase = purchaseReady();
      continueButton.disabled = !canPurchase;
      checkoutButton.disabled = !canPurchase;
    }

    function checkoutUrl() {
      return new URL(root.dataset.checkoutUrl, window.location.origin).href;
    }

    function navigateToCheckout() {
      const url = checkoutUrl();
      if (window.top !== window.self) {
        window.open(url, '_top');
        return;
      }
      window.location.assign(url);
    }

    function submitCheckoutNatively() {
      sourceProperty.value = sourceLabel();
      fileNameProperty.value = state.file.name;
      checkoutReturn.disabled = false;
      submitting = true;
      continueButton.disabled = true;
      checkoutButton.disabled = true;
      checkoutButton.classList.add('is-loading');
      checkoutLabel.textContent = copy.copyAdding;
      status.textContent = copy.copyAdding;
      emit(root, 'ai_checkout_started', Object.assign(configurationPayload(), {
        value: state.variant.variant.price / 100,
        upload_method: 'native_form'
      }));
      orderForm.submit();
    }

    function resetOrderResult() {
      orderResult.hidden = true;
      continueButton.classList.remove('is-added');
      addedConfigurationKey = '';
      if (!submitting) {
        setPurchaseLabels();
        syncPurchaseAvailability();
      }
    }

    function syncFileInput(file) {
      if (!file || fileInput.files && fileInput.files[0] === file) return;
      try {
        const transfer = new DataTransfer();
        transfer.items.add(file);
        fileInput.files = transfer.files;
      } catch (_) {}
    }

    function updateQuality() {
      if (!state.file || !state.imageWidth || !state.imageHeight) return;
      const dpi = Math.floor(Math.min(state.imageWidth / state.width, state.imageHeight / state.height));
      let label = copy.copyResolutionReview;
      if (dpi >= 300) label = copy.copyResolutionHigh;
      else if (dpi >= 150) label = copy.copyResolutionWorkable;
      root.querySelector('[data-diag="quality"]').textContent = label + ' · ' + dpi + ' DPI';
      root.querySelector('[data-diag="dimensions"]').textContent = state.imageWidth + ' × ' + state.imageHeight + ' px';
    }

    function analyzeTransparency(image) {
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d', { willReadFrequently: true });
      if (!context) return false;
      const scale = Math.min(1, 160 / Math.max(image.naturalWidth, image.naturalHeight));
      canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
      canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      const pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
      for (let index = 3; index < pixels.length; index += 4) if (pixels[index] < 250) return true;
      return false;
    }

    function recommendSize() {
      if (!state.imageWidth || !state.imageHeight || configurationTouched) return;
      const ratio = state.imageWidth / state.imageHeight;
      if (ratio >= 1) {
        state.width = 3;
        state.height = snap(3 / ratio);
      } else {
        state.height = 3;
        state.width = snap(3 * ratio);
      }
      widthInput.value = state.width;
      heightInput.value = state.height;
    }

    async function handleFile(file) {
      if (!file) return;
      if (!/^image\//.test(file.type) && file.type !== 'application/pdf') {
        status.textContent = copy.copyError;
        return;
      }
      if (file.size > 20 * 1024 * 1024) {
        status.textContent = copy.copyFileTooLarge;
        return;
      }
      syncFileInput(file);
      resetOrderResult();
      state.file = file;
      status.textContent = copy.copyReading;
      emptyState.hidden = true;
      preview.hidden = false;
      diagnostics.hidden = false;
      if (state.objectUrl) URL.revokeObjectURL(state.objectUrl);
      state.objectUrl = URL.createObjectURL(file);
      root.querySelector('[data-diag="file"]').textContent = file.name + ' · ' + humanFileSize(file.size);

      if (file.type === 'application/pdf') {
        previewImage.hidden = true;
        pdfPreview.hidden = false;
        state.imageWidth = 0;
        state.imageHeight = 0;
        state.transparent = false;
        root.querySelector('[data-diag="dimensions"]').textContent = 'PDF';
        root.querySelector('[data-diag="alpha"]').textContent = copy.copySolid;
        root.querySelector('[data-diag="quality"]').textContent = copy.copyResolutionWorkable;
      } else {
        pdfPreview.hidden = true;
        previewImage.hidden = false;
        previewImage.src = state.objectUrl;
        await new Promise(function(resolve, reject){
          previewImage.onload = resolve;
          previewImage.onerror = reject;
        });
        state.imageWidth = previewImage.naturalWidth;
        state.imageHeight = previewImage.naturalHeight;
        state.transparent = analyzeTransparency(previewImage);
        recommendSize();
        root.querySelector('[data-diag="dimensions"]').textContent = state.imageWidth + ' × ' + state.imageHeight + ' px';
        root.querySelector('[data-diag="alpha"]').textContent = state.transparent ? copy.copyTransparent : copy.copySolid;
        updateQuality();
      }

      status.textContent = copy.copyReady + ' ' + file.name;
      mobileFile.textContent = file.name;
      fileNameProperty.value = file.name;
      sourceProperty.value = sourceLabel();
      syncPurchaseAvailability();
      emit(root, 'ai_artwork_selected', { file_type: file.type, file_size: file.size, source: sourceFromVisit() });
      updatePrice();
    }

    function productUrl(route) {
      return route.replace(/\/$/, '') + '.js';
    }

    async function loadProduct(route) {
      if (productCache.has(route)) return productCache.get(route);
      const response = await fetch(productUrl(route), { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Product unavailable');
      const product = await response.json();
      productCache.set(route, product);
      return product;
    }

    function optionNumber(value) {
      return parseFloat(String(value || '').replace(/[^0-9.]/g, ''));
    }

    function quantities(product) {
      return Array.from(new Set(product.variants.map(function(variant){ return parseInt(String(variant.option3 || '').replace(/,/g, ''), 10); }).filter(Boolean))).sort(function(a,b){ return a-b; });
    }

    function renderQuantities(list) {
      quantityGrid.innerHTML = '';
      if (!list.length) {
        quantityGrid.innerHTML = '<span class="ccai__loading">' + copy.copyUnavailable + '</span>';
        return;
      }
      if (list.indexOf(state.quantity) === -1) state.quantity = list.reduce(function(best, quantity){ return Math.abs(quantity - 25) < Math.abs(best - 25) ? quantity : best; }, list[0]);
      list.slice(0, 10).forEach(function(quantity){
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.quantity = quantity;
        button.textContent = quantity >= 1000 && quantity % 1000 === 0 ? quantity / 1000 + 'K' : quantity;
        button.className = quantity === state.quantity ? 'is-active' : '';
        button.setAttribute('aria-pressed', quantity === state.quantity ? 'true' : 'false');
        button.addEventListener('click', function(){
          state.quantity = quantity;
          setPressed(quantityGrid.querySelectorAll('button'), button);
          updatePrice();
          emit(root, 'ai_configuration_changed', configurationPayload());
        });
        quantityGrid.appendChild(button);
      });
    }

    function findVariant(product) {
      const requestedLow = Math.min(state.width, state.height);
      const requestedHigh = Math.max(state.width, state.height);
      let best = null;
      let bestArea = Infinity;
      product.variants.forEach(function(variant){
        const quantity = parseInt(String(variant.option3 || '').replace(/,/g, ''), 10);
        if (quantity !== state.quantity || variant.available === false) return;
        const width = optionNumber(variant.option1);
        const height = optionNumber(variant.option2);
        const low = Math.min(width, height);
        const high = Math.max(width, height);
        const area = width * height;
        if (low >= requestedLow && high >= requestedHigh && area < bestArea) {
          bestArea = area;
          best = { variant: variant, width: width, height: height };
        }
      });
      return best;
    }

    function configurationPayload() {
      return { shape: state.shape, width: state.width, height: state.height, quantity: state.quantity, finish: state.finish, has_artwork: Boolean(state.file) };
    }

    function configurationKey() {
      return [variantInput.value, state.finish, state.file && state.file.name, state.file && state.file.size, state.file && state.file.lastModified].join('|');
    }

    async function updatePrice(refreshQuantity) {
      const requestId = ++priceRequest;
      resetOrderResult();
      totalOutput.textContent = '—';
      eachOutput.textContent = copy.copyPriceLoading;
      chargedOutput.textContent = '—';
      continueButton.disabled = true;
      checkoutButton.disabled = true;
      try {
        const product = await loadProduct(state.route);
        if (requestId !== priceRequest) return;
        state.product = product;
        if (refreshQuantity || !quantityGrid.querySelector('button')) renderQuantities(quantities(product));
        state.variant = findVariant(product);
        if (!state.variant) throw new Error('No matching variant');
        const total = state.variant.variant.price / 100;
        totalOutput.textContent = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(total);
        eachOutput.textContent = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }).format(total / state.quantity) + ' ' + copy.copyEach.toLowerCase();
        chargedOutput.textContent = copy.copyCharged + ' ' + state.variant.width + ' × ' + state.variant.height + ' in';
        mobilePrice.textContent = totalOutput.textContent;
        variantInput.value = String(state.variant.variant.id).replace('gid://shopify/ProductVariant/', '');
        finishProperty.value = state.finish;
        requestedSizeProperty.value = state.width + ' in × ' + state.height + ' in';
        cutSizeProperty.value = state.variant.width + ' in × ' + state.variant.height + ' in';
        shapeProperty.value = state.shape;
        setPurchaseLabels();
        syncPurchaseAvailability();
      } catch (error) {
        if (requestId !== priceRequest) return;
        state.variant = null;
        totalOutput.textContent = '—';
        eachOutput.textContent = copy.copyPriceError;
        chargedOutput.textContent = copy.copyUnavailable;
        variantInput.value = '';
        continueButton.disabled = true;
        checkoutButton.disabled = true;
      }
    }

    async function addToCart(event) {
      event.preventDefault();
      if (submitting) return;
      const checkoutNow = checkoutIntent;
      checkoutIntent = false;
      if (!state.file || !state.variant || !variantInput.value) {
        dropzone.focus();
        status.textContent = copy.copyError;
        return;
      }
      if (!rightsInput.checked) {
        rightsInput.focus();
        status.textContent = copy.copyRightsRequired;
        return;
      }
      const context = {
        source: sourceFromVisit(),
        landing: window.location.pathname,
        fileName: state.file.name,
        fileType: state.file.type,
        shape: state.shape,
        width: state.width,
        height: state.height,
        quantity: state.quantity,
        finish: state.finish
      };

      sourceProperty.value = sourceLabel();
      fileNameProperty.value = state.file.name;
      const formData = new FormData(orderForm);
      checkoutReturn.disabled = true;
      formData.set('properties[Artwork]', state.file, state.file.name);
      const activeButton = checkoutNow ? checkoutButton : continueButton;
      const activeLabel = checkoutNow ? checkoutLabel : continueLabel;

      submitting = true;
      continueButton.disabled = true;
      checkoutButton.disabled = true;
      activeButton.classList.add('is-loading');
      activeLabel.textContent = copy.copyAdding;
      status.textContent = copy.copyAdding;
      const requestController = new AbortController();
      const requestTimeout = window.setTimeout(function(){ requestController.abort(); }, 45000);
      try {
        const response = await fetch(root.dataset.cartAddUrl + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
          credentials: 'same-origin',
          signal: requestController.signal
        });
        if (!response.ok) throw new Error('Cart request failed');
        const item = await response.json();
        emit(root, 'ai_order_added', Object.assign(context, {
          variant_id: item.variant_id || variantInput.value,
          value: state.variant.variant.price / 100
        }));
        addedConfigurationKey = configurationKey();
        if (checkoutNow) {
          status.textContent = copy.copyOpeningCheckout;
          checkoutLabel.textContent = copy.copyOpeningCheckout;
          emit(root, 'ai_checkout_started', Object.assign(context, { value: state.variant.variant.price / 100 }));
          navigateToCheckout();
          return;
        }
        activeButton.classList.remove('is-loading');
        continueButton.classList.add('is-added');
        continueLabel.textContent = copy.copyAdded;
        checkoutLabel.textContent = copy.copyCheckout + ' · ' + totalOutput.textContent;
        status.textContent = copy.copyAdded;
        syncPurchaseAvailability();
        orderResult.hidden = false;
        fetch(root.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })
          .then(function(cartResponse){ return cartResponse.ok ? cartResponse.json() : null; })
          .then(function(cart){
            if (!cart) return;
            document.querySelectorAll('[data-cart-count]').forEach(function(node){ node.textContent = cart.item_count; });
            document.dispatchEvent(new CustomEvent('carrco:cart-updated', { detail: cart }));
          })
          .catch(function(){});
      } catch (_) {
        continueButton.classList.remove('is-loading');
        checkoutButton.classList.remove('is-loading');
        setPurchaseLabels();
        syncPurchaseAvailability();
        status.textContent = copy.copyCartError;
        emit(root, 'ai_order_error', context);
      } finally {
        window.clearTimeout(requestTimeout);
        submitting = false;
      }
    }

    root.querySelector('.ccai__browse').addEventListener('click', function(){ fileInput.click(); });
    root.querySelector('.ccai__replace').addEventListener('click', function(){ fileInput.click(); });
    fileInput.addEventListener('change', function(){ handleFile(fileInput.files && fileInput.files[0]).catch(function(){ status.textContent = copy.copyError; }); });
    dropzone.addEventListener('keydown', function(event){ if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); fileInput.click(); } });
    ['dragenter','dragover'].forEach(function(name){ dropzone.addEventListener(name, function(event){ event.preventDefault(); dropzone.classList.add('is-dragging'); }); });
    ['dragleave','drop'].forEach(function(name){ dropzone.addEventListener(name, function(event){ event.preventDefault(); dropzone.classList.remove('is-dragging'); }); });
    dropzone.addEventListener('drop', function(event){ const file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0]; handleFile(file).catch(function(){ status.textContent = copy.copyError; }); });
    dropzone.addEventListener('paste', function(event){ const items = Array.from(event.clipboardData && event.clipboardData.items || []); const imageItem = items.find(function(item){ return item.type.indexOf('image/') === 0; }); if (imageItem) { const blob = imageItem.getAsFile(); handleFile(new File([blob], 'ChatGPT-artwork-' + Date.now() + '.png', { type: blob.type })).catch(function(){ status.textContent = copy.copyError; }); } });
    root.querySelector('.ccai__paste').addEventListener('click', async function(){
      try {
        if (!navigator.clipboard || !navigator.clipboard.read) throw new Error('Clipboard unsupported');
        const items = await navigator.clipboard.read();
        for (const item of items) {
          const type = item.types.find(function(value){ return value.indexOf('image/') === 0; });
          if (type) {
            const blob = await item.getType(type);
            await handleFile(new File([blob], 'ChatGPT-artwork-' + Date.now() + '.png', { type: type }));
            return;
          }
        }
        throw new Error('No image');
      } catch (_) {
        status.textContent = copy.copyClipboardError;
        fileInput.click();
      }
    });

    root.querySelectorAll('.ccai__shape-grid button').forEach(function(button){
      button.addEventListener('click', function(){
        configurationTouched = true;
        state.shape = button.dataset.shape;
        state.route = button.dataset.route;
        setPressed(root.querySelectorAll('.ccai__shape-grid button'), button);
        updatePrice(true);
        emit(root, 'ai_configuration_changed', configurationPayload());
      });
    });

    [widthInput, heightInput].forEach(function(input){
      input.addEventListener('input', function(){
        configurationTouched = true;
        state.width = snap(parseFloat(widthInput.value) || .5);
        state.height = snap(parseFloat(heightInput.value) || .5);
        updateQuality();
        updatePrice();
      });
      input.addEventListener('change', function(){ emit(root, 'ai_configuration_changed', configurationPayload()); });
    });

    root.querySelectorAll('.ccai__finish-grid button').forEach(function(button){
      button.addEventListener('click', function(){
        state.finish = button.dataset.finish;
        finishProperty.value = state.finish;
        resetOrderResult();
        setPressed(root.querySelectorAll('.ccai__finish-grid button'), button);
        emit(root, 'ai_configuration_changed', configurationPayload());
      });
    });

    rightsInput.addEventListener('change', function(){
      resetOrderResult();
      syncPurchaseAvailability();
    });

    orderForm.addEventListener('submit', addToCart);
    checkoutButton.addEventListener('click', function(){
      if (checkoutButton.disabled) return;
      if (addedConfigurationKey && addedConfigurationKey === configurationKey()) {
        emit(root, 'ai_checkout_started', Object.assign(configurationPayload(), { value: state.variant.variant.price / 100 }));
        navigateToCheckout();
        return;
      }
      if (fileInput.files && fileInput.files.length) {
        submitCheckoutNatively();
        return;
      }
      checkoutIntent = true;
      orderForm.requestSubmit();
    });
    mobileButton.addEventListener('click', function(){
      if (checkoutButton.disabled) document.getElementById('ai-print-studio').scrollIntoView({ behavior: 'smooth' });
      else checkoutButton.click();
    });
    root.querySelector('.ccai__copy-prompt').addEventListener('click', async function(){
      const field = root.querySelector('#ccai-prompt-text');
      const text = field.value;
      const output = root.querySelector('.ccai__copy-status');
      let copied = false;
      field.focus();
      field.select();
      field.setSelectionRange(0, field.value.length);
      try { copied = document.execCommand('copy'); } catch (_) {}
      field.setSelectionRange(0, 0);
      field.blur();
      if (!copied && navigator.clipboard && navigator.clipboard.writeText) {
        try { await navigator.clipboard.writeText(text); copied = true; } catch (_) {}
      }
      output.textContent = copied ? copy.copyCopySuccess : copy.copyCopyError;
    });

    emit(root, 'ai_studio_viewed', { source: sourceFromVisit() });
    updatePrice(true);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrco-shape-order"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.ccshape').forEach(function(root){
    const copy = root.dataset;
    const variants = JSON.parse(root.querySelector('[data-shape-variants]').textContent);
    const starterButton = root.querySelector('[data-starter-add]');
    const handle = root.dataset.productHandle;
    const form = root.querySelector('.ccshape__form');
    const fileInput = root.querySelector('.ccshape__file');
    const dropzone = root.querySelector('.ccshape__dropzone');
    const empty = root.querySelector('.ccshape__empty');
    const preview = root.querySelector('.ccshape__preview');
    const render = root.querySelector('.ccshape__render');
    const image = render.querySelector('img');
    const pdf = root.querySelector('.ccshape__pdf');
    const replace = root.querySelector('.ccshape__replace');
    const status = root.querySelector('.ccshape__status');
    const diagnostics = root.querySelector('.ccshape__diagnostics');
    const resolution = root.querySelector('.ccshape__resolution');
    const resolutionCopy = root.querySelector('[data-resolution-copy]');
    const widthInput = root.querySelector('.ccshape__width');
    const heightInput = root.querySelector('.ccshape__height');
    const quantityGrid = root.querySelector('.ccshape__quantities');
    const totalOutput = root.querySelector('[data-price="total"]');
    const eachOutput = root.querySelector('[data-price="each"]');
    const cutOutput = root.querySelector('[data-price="cut"]');
    const addButton = root.querySelector('.ccshape__add');
    const addLabel = root.querySelector('[data-add-label]');
    const checkoutButton = root.querySelector('.ccshape__checkout');
    const checkoutLabel = root.querySelector('[data-checkout-label]');
    const rights = root.querySelector('.ccshape__rights input');
    const checkoutReturn = root.querySelector('[data-checkout-return]');
    const added = root.querySelector('.ccshape__added');
    const variantInput = form.querySelector('[name="id"]');
    const finishProperty = form.querySelector('[name="properties[Finish]"]');
    const requestedSizeProperty = form.querySelector('[name="properties[Requested Size]"]');
    const cutSizeProperty = form.querySelector('[name="properties[Cut Size]"]');
    const resolutionProperty = form.querySelector('[name="properties[Resolution at selected size]"]');
    const fileNameProperty = form.querySelector('[name="properties[_Artwork filename]"]');
    const artworkDeliveryProperty = form.querySelector('[data-artwork-delivery]');
    const configs = {
      'circle-stickers': { lock: true, shape: 'circle', width: 2, height: 2 },
      'square-stickers': { lock: true, shape: 'square', width: 2, height: 2 },
      'badge-stickers': { lock: true, shape: 'badge', width: 2, height: 2 },
      'hexagon-stickers': { lock: true, shape: 'hexagon', width: 2, height: 2 },
      'rectangle-stickers': { lock: false, shape: 'rectangle', width: 3, height: 2 },
      'rounded-corner-stickers': { lock: false, shape: 'rounded', width: 3, height: 2 },
      'oval-stickers': { lock: false, shape: 'oval', width: 3, height: 2 },
      'arch-stickers': { lock: false, shape: 'arch', width: 2, height: 2 },
      'die-cut-stickers': { lock: false, shape: 'custom', width: 2, height: 2 },
      'custom-shape-stickers': { lock: false, shape: 'custom', width: 2, height: 2 }
    };
    const config = configs[handle] || configs['custom-shape-stickers'];
    const state = { file: null, objectUrl: '', imageWidth: 0, imageHeight: 0, width: config.width, height: config.height, quantity: 25, finish: 'Glossy', variant: null, cutWidth: 0, cutHeight: 0 };
    let submitting = false;
    let checkoutIntent = false;
    let addedKey = '';

    if (starterButton) {
      starterButton.addEventListener('click', async function(){
        const original = starterButton.innerHTML;
        starterButton.disabled = true;
        starterButton.textContent = 'Adding your starter run...';
        try {
          const response = await fetch(root.dataset.cartAddUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: Number(starterButton.dataset.variantId),
                quantity: 1,
                properties: {
                  'Requested shape': starterButton.dataset.requestedShape,
                  'Artwork delivery': 'Send after checkout',
                  '_Order source': 'Shape page $10 starter'
                }
              }]
            })
          });
          if (!response.ok) throw new Error('Starter run could not be added.');
          const cartUrl = new URL(root.dataset.cartUrl, window.location.origin).href;
          if (window.top !== window.self) window.open(cartUrl, '_top');
          else window.location.assign(cartUrl);
        } catch (error) {
          starterButton.disabled = false;
          starterButton.innerHTML = original;
          window.alert(error.message || copy.copyCartError);
        }
      });
    }

    function number(value) {
      return parseFloat(String(value || '').replace(/[^0-9.]/g, ''));
    }

    function snap(value) {
      return Math.max(.5, Math.round(value * 2) / 2);
    }

    function formatMoney(cents) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
    }

    function fileSize(bytes) {
      if (bytes < 1024 * 1024) return Math.max(1, Math.round(bytes / 1024)) + ' KB';
      return (bytes / 1024 / 1024).toFixed(1) + ' MB';
    }

    function selected(buttons, active) {
      buttons.forEach(function(button){
        const on = button === active;
        button.classList.toggle('is-active', on);
        button.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function configurationKey() {
      return [variantInput.value, state.finish, state.file && state.file.name, state.file && state.file.size, state.file && state.file.lastModified].join('|');
    }

    function purchaseReady() {
      return Boolean(state.variant && variantInput.value && rights.checked);
    }

    function syncButtons() {
      const ready = purchaseReady() && !submitting;
      addButton.disabled = !ready;
      checkoutButton.disabled = !ready;
    }

    function resetAdded() {
      added.hidden = true;
      addedKey = '';
      addLabel.textContent = copy.copyAdd;
      checkoutLabel.textContent = copy.copyCheckout + (totalOutput.textContent !== '—' ? ' · ' + totalOutput.textContent : '');
      syncButtons();
    }

    function quantities() {
      return Array.from(new Set(variants.map(function(variant){ return parseInt(String(variant.option3 || '').replace(/,/g, ''), 10); }).filter(Boolean))).sort(function(a,b){ return a-b; });
    }

    function renderQuantities() {
      const values = quantities();
      if (values.indexOf(state.quantity) === -1) state.quantity = values.indexOf(25) > -1 ? 25 : values[0];
      quantityGrid.innerHTML = '';
      values.slice(0, 10).forEach(function(quantity){
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = quantity >= 1000 && quantity % 1000 === 0 ? quantity / 1000 + 'K' : quantity;
        button.className = quantity === state.quantity ? 'is-active' : '';
        button.setAttribute('aria-pressed', quantity === state.quantity ? 'true' : 'false');
        button.addEventListener('click', function(){
          state.quantity = quantity;
          selected(quantityGrid.querySelectorAll('button'), button);
          updateConfiguration();
        });
        quantityGrid.appendChild(button);
      });
    }

    function findVariant() {
      const requestedLow = Math.min(state.width, state.height);
      const requestedHigh = Math.max(state.width, state.height);
      let best = null;
      let bestArea = Infinity;
      variants.forEach(function(variant){
        const quantity = parseInt(String(variant.option3 || '').replace(/,/g, ''), 10);
        if (quantity !== state.quantity || variant.available === false) return;
        const width = number(variant.option1);
        const height = number(variant.option2);
        const low = Math.min(width, height);
        const high = Math.max(width, height);
        const area = width * height;
        if (low >= requestedLow && high >= requestedHigh && area < bestArea) {
          bestArea = area;
          best = { data: variant, width: width, height: height };
        }
      });
      return best;
    }

    function updateResolution() {
      if (!state.file || !state.imageWidth || !state.imageHeight) {
        resolution.dataset.resolution = 'empty';
        return;
      }
      const dpi = Math.floor(Math.min(state.imageWidth / state.width, state.imageHeight / state.height));
      let level = 'low';
      let label = copy.copyLow;
      if (dpi >= 300) {
        level = 'high';
        label = copy.copyHigh;
      } else if (dpi >= 200) {
        level = 'good';
        label = copy.copyGood;
      } else if (dpi >= 150) {
        level = 'review';
        label = copy.copyReview;
      }
      resolution.dataset.resolution = level;
      resolutionCopy.textContent = label + ' · ' + dpi + ' DPI';
      root.querySelector('[data-diag="dpi"]').textContent = dpi + ' DPI';
      root.querySelector('[data-diag="result"]').textContent = label;
      resolutionProperty.value = dpi + ' DPI · ' + label;
    }

    function updatePreviewShape() {
      render.className = 'ccshape__render is-' + config.shape;
      render.style.setProperty('--shape-ratio', state.width + '/' + state.height);
    }

    function updateConfiguration() {
      resetAdded();
      state.width = snap(parseFloat(widthInput.value) || state.width);
      state.height = config.lock ? state.width : snap(parseFloat(heightInput.value) || state.height);
      widthInput.value = state.width;
      heightInput.value = state.height;
      state.variant = findVariant();
      updatePreviewShape();
      updateResolution();
      if (!state.variant) {
        totalOutput.textContent = '—';
        eachOutput.textContent = '—';
        cutOutput.textContent = '—';
        variantInput.value = '';
        syncButtons();
        return;
      }
      state.cutWidth = state.variant.width;
      state.cutHeight = state.variant.height;
      const total = state.variant.data.price;
      totalOutput.textContent = formatMoney(total);
      eachOutput.textContent = formatMoney(total / state.quantity) + ' ' + copy.copyEach.toLowerCase();
      cutOutput.textContent = copy.copyProduced + ' ' + state.cutWidth + ' × ' + state.cutHeight + ' in';
      variantInput.value = String(state.variant.data.id).replace('gid://shopify/ProductVariant/', '');
      finishProperty.value = state.finish;
      requestedSizeProperty.value = state.width + ' in × ' + state.height + ' in';
      cutSizeProperty.value = state.cutWidth + ' in × ' + state.cutHeight + ' in';
      checkoutLabel.textContent = copy.copyCheckout + ' · ' + totalOutput.textContent;
      syncButtons();
    }

    function syncFile(file) {
      try {
        if (fileInput.files && fileInput.files[0] === file) return;
        const transfer = new DataTransfer();
        transfer.items.add(file);
        fileInput.files = transfer.files;
      } catch (_) {}
    }

    async function handleFile(file) {
      if (!file) return;
      if (!/^image\//.test(file.type) && file.type !== 'application/pdf') {
        status.textContent = copy.copyInvalid;
        return;
      }
      if (file.size > 20 * 1024 * 1024) {
        status.textContent = copy.copyTooLarge;
        return;
      }
      syncFile(file);
      state.file = file;
      resetAdded();
      status.textContent = copy.copyReading;
      empty.hidden = true;
      preview.hidden = false;
      diagnostics.hidden = false;
      if (state.objectUrl) URL.revokeObjectURL(state.objectUrl);
      state.objectUrl = URL.createObjectURL(file);
      fileNameProperty.value = file.name;
      artworkDeliveryProperty.value = 'Uploaded with order';
      root.querySelector('[data-diag="file"]').textContent = file.name + ' · ' + fileSize(file.size);
      if (file.type === 'application/pdf') {
        image.hidden = true;
        pdf.hidden = false;
        state.imageWidth = 0;
        state.imageHeight = 0;
        root.querySelector('[data-diag="pixels"]').textContent = 'PDF';
        root.querySelector('[data-diag="dpi"]').textContent = copy.copyReview;
        root.querySelector('[data-diag="result"]').textContent = copy.copyReview;
        resolution.dataset.resolution = 'review';
        resolutionCopy.textContent = copy.copyReview;
        resolutionProperty.value = copy.copyReview;
      } else {
        image.hidden = false;
        pdf.hidden = true;
        image.src = state.objectUrl;
        await new Promise(function(resolve,reject){ image.onload = resolve; image.onerror = reject; });
        state.imageWidth = image.naturalWidth;
        state.imageHeight = image.naturalHeight;
        root.querySelector('[data-diag="pixels"]').textContent = state.imageWidth + ' × ' + state.imageHeight + ' px';
        updateResolution();
      }
      status.textContent = copy.copyReady + ' ' + file.name;
      syncButtons();
    }

    function checkoutUrl() {
      return new URL(root.dataset.checkoutUrl, window.location.origin).href;
    }

    function navigateToCheckout() {
      const url = checkoutUrl();
      if (window.top !== window.self) {
        window.open(url, '_top');
        return;
      }
      window.location.assign(url);
    }

    function submitCheckout() {
      form.action = root.dataset.cartAddUrl;
      checkoutReturn.disabled = false;
      submitting = true;
      addButton.disabled = true;
      checkoutButton.disabled = true;
      checkoutButton.classList.add('is-loading');
      checkoutLabel.textContent = copy.copyUploading;
      status.textContent = copy.copyUploading;
      form.submit();
    }

    async function addToCart(event) {
      event.preventDefault();
      if (submitting) return;
      const checkoutNow = checkoutIntent;
      checkoutIntent = false;
      if (!purchaseReady()) {
        if (!rights.checked) {
          rights.focus();
          status.textContent = copy.copyRights;
        } else {
          fileInput.click();
        }
        return;
      }
      const data = new FormData(form);
      checkoutReturn.disabled = true;
      if (state.file) {
        data.set('properties[Artwork]', state.file, state.file.name);
        artworkDeliveryProperty.value = 'Uploaded with order';
      } else {
        data.delete('properties[Artwork]');
        artworkDeliveryProperty.value = 'Send after checkout';
      }
      submitting = true;
      addButton.disabled = true;
      checkoutButton.disabled = true;
      const active = checkoutNow ? checkoutButton : addButton;
      const label = checkoutNow ? checkoutLabel : addLabel;
      active.classList.add('is-loading');
      label.textContent = copy.copyUploading;
      status.textContent = copy.copyUploading;
      const controller = new AbortController();
      const timeout = window.setTimeout(function(){ controller.abort(); }, 45000);
      try {
        const response = await fetch(root.dataset.cartAddUrl + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: data,
          credentials: 'same-origin',
          signal: controller.signal
        });
        if (!response.ok) throw new Error('Cart request failed');
        await response.json();
        addedKey = configurationKey();
        if (checkoutNow) {
          navigateToCheckout();
          return;
        }
        active.classList.remove('is-loading');
        addLabel.textContent = copy.copyAdded;
        checkoutLabel.textContent = copy.copyCheckout + ' · ' + totalOutput.textContent;
        status.textContent = copy.copyAdded;
        added.hidden = false;
        fetch(root.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })
          .then(function(cartResponse){ return cartResponse.ok ? cartResponse.json() : null; })
          .then(function(cart){
            if (!cart) return;
            document.querySelectorAll('[data-cart-count]').forEach(function(node){ node.textContent = cart.item_count; });
            document.dispatchEvent(new CustomEvent('carrco:cart-updated', { detail: cart }));
          })
          .catch(function(){});
      } catch (_) {
        addButton.classList.remove('is-loading');
        checkoutButton.classList.remove('is-loading');
        addLabel.textContent = copy.copyAdd;
        checkoutLabel.textContent = copy.copyCheckout + ' · ' + totalOutput.textContent;
        status.textContent = copy.copyCartError;
      } finally {
        window.clearTimeout(timeout);
        submitting = false;
        syncButtons();
      }
    }

    widthInput.value = state.width;
    heightInput.value = state.height;
    heightInput.disabled = config.lock;
    renderQuantities();
    updateConfiguration();

    fileInput.addEventListener('change', function(){ handleFile(fileInput.files && fileInput.files[0]).catch(function(){ status.textContent = copy.copyInvalid; }); });
    replace.addEventListener('click', function(event){ event.preventDefault(); fileInput.click(); });
    dropzone.addEventListener('dragover', function(event){ event.preventDefault(); dropzone.classList.add('is-dragging'); });
    dropzone.addEventListener('dragleave', function(){ dropzone.classList.remove('is-dragging'); });
    dropzone.addEventListener('drop', function(event){
      event.preventDefault();
      dropzone.classList.remove('is-dragging');
      handleFile(event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0]).catch(function(){ status.textContent = copy.copyInvalid; });
    });
    root.addEventListener('paste', function(event){
      const items = Array.from(event.clipboardData && event.clipboardData.items || []);
      const item = items.find(function(entry){ return entry.type.indexOf('image/') === 0; });
      if (item) handleFile(item.getAsFile()).catch(function(){ status.textContent = copy.copyInvalid; });
    });
    [widthInput,heightInput].forEach(function(input){ input.addEventListener('input', updateConfiguration); });
    root.querySelectorAll('.ccshape__finishes button').forEach(function(button){
      button.addEventListener('click', function(){
        state.finish = button.dataset.finish;
        selected(root.querySelectorAll('.ccshape__finishes button'), button);
        updateConfiguration();
      });
    });
    rights.addEventListener('change', syncButtons);
    addButton.addEventListener('click', addToCart);
    checkoutButton.addEventListener('click', function(){
      if (checkoutButton.disabled) return;
      if (addedKey && addedKey === configurationKey()) {
        navigateToCheckout();
        return;
      }
      submitCheckout();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
